






























import Vue from 'vue';
import { MappedItem } from '../mapper_types';

export default Vue.extend({
  name: 'SelectItem',
  props: {
    item: {
      type: Object as () => MappedItem,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  computed: {
    modelMeta() {
      if (!this.$store) return {};
      return this.$store.getters.modelMeta;
    },
    isFetcherType() {
      return !!this.modelMeta && !!this.modelMeta.fetcher && this.objectType === this.modelMeta.fetcher.modelSingular;
    },
  },
  methods: {
    openObjectDetailsModal(ev: MouseEvent): void {
      if (this.isFetcherType) {
        ev.preventDefault();
        return;
      }
      if (!this.$store) {
        ev.preventDefault();
        window.GGRC.zenModal.show({
          type: 'ObjectInfo',
          data: {
            id: this.item.id,
            type: this.objectType,
          },
        });
      }
    },
    selectItem(ev: MouseEvent) {
      this.item.selected = !this.item.selected;
      this.$emit('selected', this.item, ev);
    },
  },
});
